@if (estrutura(); as e) {
  @if (visao().estruturas.length > 1) {
    <div class="ctl__pick">
      @for (item of visao().estruturas; track item.socio.id) {
        <button
          type="button"
          class="ctl__pill"
          [class.ctl__pill--on]="item.socio.id === e.socio.id"
          (click)="selecionada.set(item.socio.id)">
          {{ item.socio.nome }}
        </button>
      }
    </div>
  }
  <div class="ctl__head">
    <div>
      <p class="ctl__title">Mapa de controle societário</p>
      <p class="ctl__sub">
        {{ e.socio.nome }} como sócia PJ em {{ e.empresas.length }} empresas, com os demais sócios
        do recorte.
      </p>
    </div>
    @if (display.showHoldingBadge()) {
      <span class="holding">Possível holding</span>
    }
  </div>
  <div class="ctl__graph"><app-registry-graph [grafo]="e.grafo" /></div>
} @else {
  <p class="muted">Nenhuma estrutura de participação foi identificada neste recorte.</p>
}
